import _ from 'lodash';
import messages from './messages/shapeMessages';
import wallLocationMessages from './messages/wallLocationMessages';
import overhangMessages from './messages/overhangMessages';
import RectangularShape from './images/shapes/image_PLAN_BasicShape_Rectangle.png';
import LShape from './images/shapes/image_PLAN_BasicShape_L-shape.png';
import LShapeFlipped from './images/shapes/image_PLAN_BasicShape_L-shape_Flipped.png';
import UShape from './images/shapes/image_PLAN_BasicShape_U-shape.png';
import VShape from './images/shapes/image_PLAN_BasicShape_V-shape.png';
import VShapeFlipped from './images/shapes/image_PLAN_BasicShape_V-shape_Flipped.png';
import CShape from './images/shapes/image_PLAN_BasicShape_C-shape.png';
import CShapeFlipped from './images/shapes/image_PLAN_BasicShape_C-shape_Flipped.png';
import IIShape from './images/shapes/image_PLAN_BasicShape_II-shape.png';
import IrregularShape from './images/shapes/image_PLAN_BasicShape_Irregular.png';
import GShape from './images/shapes/image_PLAN_BasicShape_G-shape.png';
import * as wallLocations from './images/wallLocations';
import * as FlipImages from './images/shapes/flip-icon';
import * as sideImages from './images/overhangs/sides';
import { useImperial } from '../utils/convertMeasurement';

export const types = {
  DEPTH: 'depth',
  LENGTH: 'length',
  SPECIAL: 'special',
  CALCULATED: 'calculated',
};

const VSHAPE_MIN = 1216;
const CSHAPE_MIN = 413;

export const cornerSolutions = {
  frontEdge: 609,
  deepCornerVshape: 1066,
  deepCornerCshape: 263,
};

export const availableShapes = {
  rectangular: {
    image: RectangularShape,
    displayName: messages.rectangular,
    dimensions: {
      a: {
        type: types.LENGTH,
      },
      b: {
        type: types.DEPTH,
      },
    },
    wallDrawingOrder: ['b1', 'a', 'b2'],
    wallLocations: {
      'no-walls': {
        image: wallLocations.Rectangle,
        displayName: wallLocationMessages.noWalls,
        wallLocations: [],
      },
      'one-long-wall': {
        image: wallLocations.Rectangle_One_wall_side_long,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['a'],
      },
      'one-short-wall-left': {
        image: wallLocations.Rectangle_One_wall_side_short_left,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['b'],
        drawWalls: ['b1'],
      },
      'one-short-wall-right': {
        image: wallLocations.Rectangle_One_wall_side_short_right,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['b'],
        drawWalls: ['b2'],
      },
      'two-walls-left': {
        image: wallLocations.Rectangle_Two_wall_sides_left,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['a', 'b'],
        drawWalls: ['b1'],
      },
      'two-walls-right': {
        image: wallLocations.Rectangle_Two_wall_sides_right,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['a', 'b'],
        drawWalls: ['b2'],
      },
      'three-walls': {
        image: wallLocations.Rectangle_Three_wall_sides_default,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['a', 'b', 'b'],
        drawWalls: ['b1', 'b2'],
      },
    },
    overhangSides: {
      'one-side-left': {
        displayImage: sideImages.Rectangle_OH_one_Left,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'a',
            depth: 'b',
            side: 'b1',
          },
        },
      },
      'one-side-right': {
        displayImage: sideImages.Rectangle_OH_one_Right,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'a',
            depth: 'b',
            side: 'b2',
          },
        },
      },
      'two-sides': {
        displayImage: sideImages.Rectangle_OH_two,
        displayName: overhangMessages.twoSides,
        dimensions: {
          y: {
            length: 'a',
            depth: 'b',
            side: 'b1',
          },
          z: {
            length: 'a',
            depth: 'b',
            side: 'b2',
          },
        },
      },
    },
  },
  'l-shape': {
    image: LShape,
    flippedImage: LShapeFlipped,
    displayName: messages['l-shape'],
    flippable: {
      left: FlipImages.FlipL,
      right: FlipImages.FlipL2,
    },
    dimensions: {
      a: {
        type: types.LENGTH,
      },
      b: {
        type: types.LENGTH,
      },
      c: {
        type: types.DEPTH,
      },
      d: {
        type: types.DEPTH,
      },
    },
    wallDrawingOrder: ['d', 'b', 'a', 'c'],
    wallLocations: {
      'no-walls': {
        image: wallLocations.L_Shape,
        flippedImage: wallLocations.L_Shape_Flipped,
        displayName: wallLocationMessages.noWalls,
        wallLocations: [],
      },
      'one-wall-top': {
        image: wallLocations.L_shape_One_wall_side_top_left,
        flippedImage: wallLocations.L_shape_Flipped_One_wall_side_top_left,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['a'],
      },
      'one-wall-left': {
        image: wallLocations.L_shape_One_wall_side_left_left,
        flippedImage: wallLocations.L_shape_Flipped_One_wall_side_left_left,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['b'],
      },
      'two-walls-left': {
        image: wallLocations.L_shape_Two_wall_sides_left,
        flippedImage: wallLocations.L_shape_Flipped_Two_wall_sides_left,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['a', 'b'],
      },
      'two-walls-right': {
        image: wallLocations.L_shape_Two_wall_sides_right,
        flippedImage: wallLocations.L_shape_Flipped_Two_wall_sides_right,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['a', 'c'],
      },
      'three-walls-top': {
        image: wallLocations.L_shape_Three_wall_sides_top_left,
        flippedImage: wallLocations.L_shape_Flipped_Three_wall_sides_top_left,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['a', 'b', 'c'],
      },
      'three-walls-left': {
        image: wallLocations.L_shape_Three_wall_sides_left_left,
        flippedImage: wallLocations.L_shape_Flipped_Three_wall_sides_left_left,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['a', 'b', 'd'],
      },
      'four-walls': {
        image: wallLocations.L_shape_Four_wall_sides_left,
        flippedImage: wallLocations.L_shape_Flipped_Four_wall_sides_left,
        displayName: wallLocationMessages.fourWalls,
        wallLocations: ['a', 'b', 'c', 'd'],
      },
    },
    overhangSides: {
      'one-side-right': {
        displayImage: sideImages.L_Shape_OH_one_Right_up,
        flippedImage: sideImages.L_Shape_flipped_OH_one_Left_up,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'a',
            depth: 'c',
          },
        },
      },
      'one-side-bottom': {
        displayImage: sideImages.L_Shape_OH_one_Down,
        flippedImage: sideImages.L_Shape_flipped_OH_one_Down,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'b',
            depth: 'd',
          },
        },
      },
      'two-sides': {
        displayImage: sideImages.L_Shape_OH_two,
        flippedImage: sideImages.L_Shape_flipped_OH_two,
        displayName: overhangMessages.twoSides,
        dimensions: {
          y: {
            length: 'a',
            depth: 'c',
          },
          z: {
            length: 'b',
            depth: 'd',
          },
        },
      },
    },
  },
  'u-shape': {
    image: UShape,
    displayName: messages['u-shape'],
    dimensions: {
      a: {
        type: types.LENGTH,
      },
      b: {
        type: types.LENGTH,
      },
      c: {
        type: types.LENGTH,
      },
      d: {
        type: types.DEPTH,
      },
      e: {
        type: types.DEPTH,
      },
      f: {
        type: types.DEPTH,
      },
    },
    wallDrawingOrder: ['e', 'b', 'a', 'c', 'f'],
    wallLocations: {
      'no-walls': {
        image: wallLocations.U_Shape,
        displayName: wallLocationMessages.noWalls,
        wallLocations: [],
      },
      'one-wall': {
        image: wallLocations.U_shape_One_wall_side,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['a'],
      },
      'two-walls-left': {
        image: wallLocations.U_shape_Two_wall_sides_left,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['a', 'b'],
      },
      'two-walls-right': {
        image: wallLocations.U_shape_Two_wall_sides_right,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['a', 'c'],
      },
      'three-walls': {
        image: wallLocations.U_shape_Three_wall_sides,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['a', 'b', 'c'],
      },
      'three-walls-left': {
        image: wallLocations.U_shape_Three_wall_sides_left,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['a', 'b', 'e'],
      },
      'three-walls-right': {
        image: wallLocations.U_shape_Three_wall_sides_right,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['a', 'c', 'f'],
      },
      'four-walls-left': {
        image: wallLocations.U_shape_Four_wall_sides_left,
        displayName: wallLocationMessages.fourWalls,
        wallLocations: ['a', 'b', 'c', 'e'],
      },
      'four-walls-right': {
        image: wallLocations.U_shape_Four_wall_sides_right,
        displayName: wallLocationMessages.fourWalls,
        wallLocations: ['a', 'b', 'c', 'f'],
      },
      'five-walls': {
        image: wallLocations.U_shape_Five_wall_sides,
        displayName: wallLocationMessages.fiveWalls,
        wallLocations: ['a', 'b', 'c', 'e', 'f'],
      },
    },
    overhangSides: {
      'one-side-bottom-right': {
        displayImage: sideImages.U_Shape_OH_one_Right,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'c',
            depth: 'f',
          },
        },
      },
      'one-side-bottom-left': {
        displayImage: sideImages.U_Shape_OH_one_Left,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'b',
            depth: 'e',
          },
        },
      },
      'two-sides': {
        displayImage: sideImages.U_Shape_OH_two,
        displayName: overhangMessages.twoSides,
        dimensions: {
          y: {
            length: 'b',
            depth: 'e',
          },
          z: {
            length: 'c',
            depth: 'f',
          },
        },
      },
    },
  },
  'v-shape': {
    image: VShape,
    flippedImage: VShapeFlipped,
    displayName: messages['v-shape'],
    flippable: {
      left: FlipImages.FlipV,
      right: FlipImages.FlipV2,
    },
    conditions: ({ maxDepth }) => !maxDepth || (maxDepth > 1203),
    dimensions: {
      a: {
        type: types.LENGTH,
        min: VSHAPE_MIN,
      },
      b: {
        type: types.LENGTH,
        min: VSHAPE_MIN,
      },
      c: {
        type: types.DEPTH,
        defaultValue: 635,
        constant: true,
      },
      d: {
        type: types.DEPTH,
        defaultValue: 635,
        constant: true,
      },
      e: {
        type: types.SPECIAL,
        defaultValue: cornerSolutions.frontEdge,
        constant: true,
      },
    },
    wallDrawingOrder: ['d', 'b', 'a', 'c'],
    wallLocations: {
      'no-walls': {
        image: wallLocations.V_Shape,
        flippedImage: wallLocations.V_Shape_Flipped,
        displayName: wallLocationMessages.noWalls,
        wallLocations: [],
      },
      'one-wall-top': {
        image: wallLocations.V_shape_One_wall_side_top_left,
        flippedImage: wallLocations.V_shape_Flipped_One_wall_side_top_left,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['a'],
      },
      'one-wall-left': {
        image: wallLocations.V_shape_One_wall_side_left_left,
        flippedImage: wallLocations.V_shape_Flipped_One_wall_side_left_left,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['b'],
      },
      'two-walls': {
        image: wallLocations.V_shape_Two_wall_sides_left,
        flippedImage: wallLocations.V_shape_Flipped_Two_wall_sides_left,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['a', 'b'],
      },
      'three-walls-top': {
        image: wallLocations.V_shape_Three_wall_sides_top_left,
        flippedImage: wallLocations.V_shape_Flipped_Three_wall_sides_top_left,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['a', 'b', 'c'],
      },
      'three-walls-left': {
        image: wallLocations.V_shape_Three_wall_sides_left_left,
        flippedImage: wallLocations.V_shape_Flipped_Three_wall_sides_left_left,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['a', 'b', 'd'],
      },
      'four-walls': {
        image: wallLocations.V_shape_Four_wall_sides_left,
        flippedImage: wallLocations.V_shape_Flipped_Four_wall_sides_left,
        displayName: wallLocationMessages.fourWalls,
        wallLocations: ['a', 'b', 'c', 'd'],
      },
    },
    overhangSides: {
      'one-side-right': {
        displayImage: sideImages.V_Shape_OH_one_Right_up,
        flippedImage: sideImages.V_Shape_flipped_OH_one_Left_up,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'a',
            depth: 'c',
          },
        },
      },
      'one-side-bottom': {
        displayImage: sideImages.V_Shape_OH_one_Down,
        flippedImage: sideImages.V_Shape_flipped_OH_one_Down,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'b',
            depth: 'd',
          },
        },
      },
      'two-sides': {
        displayImage: sideImages.V_Shape_OH_two,
        flippedImage: sideImages.V_Shape_flipped_OH_two,
        displayName: overhangMessages.twoSides,
        dimensions: {
          y: {
            length: 'a',
            depth: 'c',
          },
          z: {
            length: 'b',
            depth: 'd',
          },
        },
      },
    },
  },
  'c-shape': {
    image: CShape,
    flippedImage: CShapeFlipped,
    displayName: messages['c-shape'],
    flippable: {
      left: FlipImages.FlipC,
      right: FlipImages.FlipC2,
    },
    conditions: ({ maxDepth }) => !maxDepth || (maxDepth >= 635),
    dimensions: {
      a: {
        type: types.LENGTH,
        min: CSHAPE_MIN,
      },
      b: {
        type: types.LENGTH,
        min: CSHAPE_MIN,
      },
      c: {
        type: types.DEPTH,
        defaultValue: 635,
        constant: true,
      },
      d: {
        type: types.DEPTH,
        defaultValue: 635,
        constant: true,
      },
      e: {
        type: types.SPECIAL,
        defaultValue: cornerSolutions.frontEdge,
        constant: true,
      },
      f: {
        type: types.SPECIAL,
        defaultValue: 1135,
        constant: true,
      },
    },
    wallDrawingOrder: ['d', 'b', 'f', 'a', 'c'],
    wallLocations: {
      'no-walls': {
        image: wallLocations.C_shape,
        flippedImage: wallLocations.C_shape_Flipped,
        displayName: wallLocationMessages.noWalls,
        wallLocations: [],
      },
      'three-walls': {
        image: wallLocations.C_shape_Three_walls,
        flippedImage: wallLocations.C_shape_Flipped_Three_walls,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['a', 'b', 'f'],
      },
      'four-walls-left': {
        image: wallLocations.C_shape_Four_walls_left,
        flippedImage: wallLocations.C_shape_Flipped_Four_walls_left,
        displayName: wallLocationMessages.fourWalls,
        wallLocations: ['a', 'b', 'f', 'd'],
      },
      'four-walls-right': {
        image: wallLocations.C_shape_Four_walls_right,
        flippedImage: wallLocations.C_shape_Flipped_Four_walls_right,
        displayName: wallLocationMessages.fourWalls,
        wallLocations: ['a', 'b', 'f', 'c'],
      },
      'five-walls': {
        image: wallLocations.C_shape_Five_walls,
        flippedImage: wallLocations.C_shape_Flipped_Five_walls,
        displayName: wallLocationMessages.fiveWalls,
        wallLocations: ['a', 'b', 'c', 'd', 'f'],
      },
    },
    overhangSides: {
      'one-side-right': {
        displayImage: sideImages.C_Shape_OH_one_Right_up,
        flippedImage: sideImages.C_Shape_flipped_OH_one_Left_up,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'a',
            depth: 'c',
          },
        },
      },
      'one-side-bottom': {
        displayImage: sideImages.C_Shape_OH_one_Down,
        flippedImage: sideImages.C_Shape_flipped_OH_one_Down,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'b',
            depth: 'd',
          },
        },
      },
      'two-sides': {
        displayImage: sideImages.C_Shape_OH_two,
        flippedImage: sideImages.C_Shape_flipped_OH_two,
        displayName: overhangMessages.twoSides,
        dimensions: {
          y: {
            length: 'a',
            depth: 'c',
          },
          z: {
            length: 'b',
            depth: 'd',
          },
        },
      },
    },
  },
  'ii-shape': {
    image: IIShape,
    displayName: messages['ii-shape'],
    dimensions: {
      a: {
        type: types.LENGTH,
      },
      b: {
        type: types.DEPTH,
      },
      c: {
        type: types.LENGTH,
      },
      d: {
        type: types.DEPTH,
      },
    },
    wallDrawingOrder: ['b1', 'a', 'b2', 'd2', 'c', 'd1'],
    wallLocations: {
      'no-walls': {
        image: wallLocations.II_Shape,
        displayName: wallLocationMessages.noWalls,
        wallLocations: [],
      },
      'one-wall-island-top': {
        image: wallLocations.II_shape_One_wall_side_island_top,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['c'],
      },
      'one-wall-island-bottom': {
        image: wallLocations.II_shape_One_wall_side_island_bottom,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['a'],
      },
      'two-long-walls': {
        image: wallLocations.II_shape_Two_wall_sides,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['a', 'c'],
      },
      'two-short-walls-left': {
        image: wallLocations.II_shape_Two_short_wall_sides_left,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['b', 'd'],
        drawWalls: ['b1', 'd1'],
      },
      'two-short-walls-right': {
        image: wallLocations.II_shape_Two_short_wall_sides_right,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['b', 'd'],
        drawWalls: ['b2', 'd2'],
      },
      'three-walls-island-top': {
        image: wallLocations.II_shape_Three_wall_sides_Island_top,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['c', 'd', 'd'],
        drawWalls: ['d1', 'd2'],
      },
      'three-walls-island-bottom': {
        image: wallLocations.II_shape_Three_wall_sides_Island_bottom,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['a', 'b', 'b'],
        drawWalls: ['b1', 'b2'],
      },
      'three-walls-left': {
        image: wallLocations.II_shape_Three_wall_sides_left,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['c', 'b', 'd'],
        drawWalls: ['b1', 'd1'],
      },
      'three-walls-right': {
        image: wallLocations.II_shape_Three_wall_sides_right,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['c', 'b', 'd'],
        drawWalls: ['b2', 'd2'],
      },
      'four-walls-left': {
        image: wallLocations.II_shape_Four_wall_sides_left,
        displayName: wallLocationMessages.fourWalls,
        wallLocations: ['a', 'b', 'c', 'd'],
        drawWalls: ['b1', 'd1'],
      },
      'four-walls-right': {
        image: wallLocations.II_shape_Four_wall_sides_right,
        displayName: wallLocationMessages.fourWalls,
        wallLocations: ['a', 'b', 'c', 'd'],
        drawWalls: ['b2', 'd2'],
      },
      'six-walls': {
        image: wallLocations.II_shape_Six_wall_sides,
        displayName: wallLocationMessages.sixWalls,
        wallLocations: ['a', 'b', 'b', 'c', 'd', 'd'],
        drawWalls: ['b1', 'b2', 'd1', 'd2'],
      },
    },
    overhangSides: {
      'one-side-top-left': {
        displayImage: sideImages.II_Shape_OH_one_Left_up,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'a',
            depth: 'b',
            side: 'b1',
          },
        },
      },
      'one-side-top-right': {
        displayImage: sideImages.II_Shape_OH_one_Right_up,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'a',
            depth: 'b',
            side: 'b2',
          },
        },
      },
      'one-side-bottom-left': {
        displayImage: sideImages.II_Shape_OH_one_Left_down,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'c',
            depth: 'd',
            side: 'd1',
          },
        },
      },
      'one-side-bottom-right': {
        displayImage: sideImages.II_Shape_OH_one_Right_down,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'c',
            depth: 'd',
            side: 'd2',
          },
        },
      },
      'two-sides-top': {
        displayImage: sideImages.II_Shape_OH_two_Left_Right_up,
        displayName: overhangMessages.twoSides,
        dimensions: {
          y: {
            length: 'a',
            depth: 'b',
            side: 'b1',
          },
          z: {
            length: 'a',
            depth: 'b',
            side: 'b2',
          },
        },
      },
      'two-sides-bottom': {
        displayImage: sideImages.II_Shape_OH_two_Left_Right_down,
        displayName: overhangMessages.twoSides,
        dimensions: {
          y: {
            length: 'c',
            depth: 'd',
            side: 'd1',
          },
          z: {
            length: 'c',
            depth: 'd',
            side: 'd2',
          },
        },
      },
      'two-sides-bottom-right-top-left': {
        displayImage: sideImages.II_Shape_OH_two_Left_up_Right_down,
        displayName: overhangMessages.twoSides,
        dimensions: {
          y: {
            length: 'a',
            depth: 'b',
            side: 'b1',
          },
          z: {
            length: 'c',
            depth: 'd',
            side: 'd2',
          },
        },
      },
      'two-sides-bottom-left-top-right': {
        displayImage: sideImages.II_Shape_OH_two_Left_down_Right_up,
        displayName: overhangMessages.twoSides,
        dimensions: {
          y: {
            length: 'a',
            depth: 'b',
            side: 'b2',
          },
          z: {
            length: 'c',
            depth: 'd',
            side: 'd1',
          },
        },
      },
      'two-sides-left': {
        displayImage: sideImages.II_Shape_OH_two_Left,
        displayName: overhangMessages.twoSides,
        dimensions: {
          y: {
            length: 'a',
            depth: 'b',
            side: 'b1',
          },
          z: {
            length: 'c',
            depth: 'd',
            side: 'd1',
          },
        },
      },
      'two-sides-right': {
        displayImage: sideImages.II_Shape_OH_two_Right,
        displayName: overhangMessages.twoSides,
        dimensions: {
          y: {
            length: 'a',
            depth: 'b',
            side: 'b2',
          },
          z: {
            length: 'c',
            depth: 'd',
            side: 'd2',
          },
        },
      },
      'three-sides-not-top-left': {
        displayImage: sideImages.II_Shape_OH_three_oneLeft_down_twoRight,
        displayName: overhangMessages.threeSides,
        dimensions: {
          x: {
            length: 'a',
            depth: 'b',
            side: 'b2',
          },
          y: {
            length: 'c',
            depth: 'd',
            side: 'd1',
          },
          z: {
            length: 'c',
            depth: 'd',
            side: 'd2',
          },
        },
      },
      'three-sides-not-top-right': {
        displayImage: sideImages.II_Shape_OH_three_twoLeft_oneRight_down,
        displayName: overhangMessages.threeSides,
        dimensions: {
          x: {
            length: 'a',
            depth: 'b',
            side: 'b1',
          },
          y: {
            length: 'c',
            depth: 'd',
            side: 'd1',
          },
          z: {
            length: 'c',
            depth: 'd',
            side: 'd2',
          },
        },
      },
      'three-sides-not-bottom-left': {
        displayImage: sideImages.II_Shape_OH_three_oneLeft_up_twoRight,
        displayName: overhangMessages.threeSides,
        dimensions: {
          x: {
            length: 'a',
            depth: 'b',
            side: 'b1',
          },
          y: {
            length: 'a',
            depth: 'b',
            side: 'b2',
          },
          z: {
            length: 'c',
            depth: 'd',
            side: 'd2',
          },
        },
      },
      'three-sides-not-bottom-right': {
        displayImage: sideImages.II_Shape_OH_three_twoLeft_oneRight_up,
        displayName: overhangMessages.threeSides,
        dimensions: {
          x: {
            length: 'a',
            depth: 'b',
            side: 'b1',
          },
          y: {
            length: 'a',
            depth: 'b',
            side: 'b2',
          },
          z: {
            length: 'c',
            depth: 'd',
            side: 'd1',
          },
        },
      },
      'four-sides': {
        displayImage: sideImages.II_Shape_OH_four,
        displayName: overhangMessages.fourSides,
        dimensions: {
          w: {
            length: 'a',
            depth: 'b',
            side: 'b1',
          },
          x: {
            length: 'a',
            depth: 'b',
            side: 'b2',
          },
          y: {
            length: 'c',
            depth: 'd',
            side: 'd1',
          },
          z: {
            length: 'c',
            depth: 'd',
            side: 'd2',
          },
        },
      },
    },
  },
  irregular: {
    image: IrregularShape,
    displayName: messages.irregular,
    dimensions: {
      a: {
        type: types.LENGTH,
      },
      b: {
        type: types.DEPTH,
      },
      c: {
        type: types.DEPTH,
      },
      d: {
        type: types.CALCULATED,
        formula: (dim) => {
          const triangleSide = Math.abs(dim.get('b') - dim.get('c'));
          return Math.sqrt((triangleSide ** 2) + (dim.get('a') ** 2));
        },
      },
    },
    sinkFasteningCondition: (sinkFasteningId) => sinkFasteningId !== 'fitBetween',
    wallDrawingOrder: ['c', 'd', 'b'],
    wallLocations: {
      'no-walls': {
        image: wallLocations.Irregular,
        displayName: wallLocationMessages.noWalls,
        wallLocations: [],
      },
      'one-long-wall': {
        image: wallLocations.Irregular_One_wall_side_long_top,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['d'],
      },
      'one-short-wall-left': {
        image: wallLocations.Irregular_One_wall_side_short_left,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['b'],
      },
      'one-short-wall-right': {
        image: wallLocations.Irregular_One_wall_side_short_right,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['c'],
      },
      'two-walls-top-right': {
        image: wallLocations.Irregular_Two_wall_side_top_right,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['d', 'c'],
      },
      'two-walls-top-left': {
        image: wallLocations.Irregular_Two_wall_side_top_left,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['d', 'b'],
      },
      'three-walls': {
        image: wallLocations.Irregular_Three_wall_side_top,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['d', 'b', 'c'],
      },
    },
    overhangSides: {
      'one-side-left': {
        displayImage: sideImages.Irregular_OH_one_Left,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'a',
            depth: 'b',
          },
        },
      },
      'one-side-right': {
        displayImage: sideImages.Irregular_OH_one_Right,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'a',
            depth: 'c',
          },
        },
      },
      'two-sides': {
        displayImage: sideImages.Irregular_OH_two,
        displayName: overhangMessages.twoSides,
        dimensions: {
          y: {
            length: 'a',
            depth: 'b',
          },
          z: {
            length: 'a',
            depth: 'c',
          },
        },
      },
    },
  },
  'g-shape':{
    image:GShape,
    displayName: messages['g-shape'],
    dimensions: {
      a: {
        type: types.LENGTH,
      },
      b: {
        type: types.LENGTH,
      },
      c: {
        type: types.LENGTH,
      },
      d: {
        type: types.LENGTH,
      },
      e: {
        type: types.DEPTH,
      },
      f: {
        type: types.DEPTH,
      },
      g: {
        type: types.DEPTH,
      },
      h: {
        type: types.DEPTH,
      },
    },
    wallDrawingOrder: ['g','d','b','a','c','h'],
    wallLocations: {
      'no-walls': {
        image: wallLocations.G_shape,
        displayName: wallLocationMessages.noWalls,
        wallLocations: [],
      },    
        'one-wall-top': {
        image:wallLocations.G_Shape_one_wall_top_side,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['a'],
      },  
        'one-wall-left': {
        image:wallLocations.G_Shape_One_wall_left_side,
        displayName: wallLocationMessages.oneWall,
        wallLocations: ['b'],
      },  
      'two-wall-left-bottom': {
        image: wallLocations.G_Shape_Two_wall_left_bottom_sides,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['b', 'd'],
      },    
      'two-wall-right-top': {
        image: wallLocations.G_Shape_Two_wall_right_top_sides,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['c', 'a'],
      },    
      'two-wall-top-left': {
        image: wallLocations.G_Shape_Two_wall_top_left_sides,
        displayName: wallLocationMessages.twoWalls,
        wallLocations: ['a', 'b'],
      },    
      'three-wall-right-top-left': {
        image: wallLocations.G_Shape_Three_wall_right_top_left_sides,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['c', 'a', 'b'],
      },      
      'three-wall-top-left-bottom': {
        image: wallLocations.G_Shape_Three_wall_top_left_bottom_sides,
        displayName: wallLocationMessages.threeWalls,
        wallLocations: ['b','a','d'],
      },    
      'four-walls': {
        image: wallLocations.G_Shape_Four_wall_sides_DEFAULT,
        displayName: wallLocationMessages.fourWalls,
        wallLocations: ['c','a','b','d'],
      },      
    },
    overhangSides: {
      'one-side-bottom-right': {
        displayImage: sideImages.G_Shape_OH_one_Left,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'd',
            depth: 'g',             
          },
        },
      },
      'one-side-right-bottom': {
        displayImage: sideImages.G_Shape_OH_one_Right,
        displayName: overhangMessages.oneSide,
        dimensions: {
          z: {
            length: 'c',
            depth: 'h',              
          },
        },
      },
      'two-sides': {
        displayImage: sideImages.G_Shape_OH_two,
        displayName: overhangMessages.twoSides,
        dimensions: {
          y: {
            length: 'd',
            depth: 'g',                 
          },
          z: {
            length: 'c',
            depth: 'h',           
          },
        },
      },
    }, 
  }
};

export function filterWallLocations(availableWallLocations, wallLocationsToUse = []) {
  const walls = wallLocationsToUse.filter((wallLocationsKey) => {    
    if (!availableWallLocations[wallLocationsKey]) {
      // eslint-disable-next-line no-console
      console.error('Excluding unknown wall location:', wallLocationsKey);
      return false;
    }

    return true;
  }).map((wallLocationsKey) => ({
    id: wallLocationsKey,
    ...availableWallLocations[wallLocationsKey],
  }));

  return walls;
}

function setDefaultMeasurementToMaxDepthForIrregularShape(dimensionId, materials, defaultMeasurement) {
  let maxDepthValue;
  materials.map((material) => {
    return material.expressions.map((expression) => (expression.thicknesses[0].priceByArea && expression.thicknesses[0].depths.map(({ maxDepth }) => {
      const minimumDefaultValue = 700;
      if (maxDepth < defaultMeasurement && maxDepth >= minimumDefaultValue) {
        if (maxDepthValue === undefined || (maxDepthValue > maxDepth)) {
          maxDepthValue = maxDepth;
          return true;
        }
      } else {
        return false;
      }
    })));
  });
  return maxDepthValue;
}

function withDefaultMeasurements(dimensions, defaultMeasurements = {}, materials) {
  return _.mapValues(dimensions, (dimension, dimensionId) => {
    if (materials && dimensionId === 'c') {
      const defaultMeasurementMaxDepth = setDefaultMeasurementToMaxDepthForIrregularShape(dimensionId, materials, defaultMeasurements[dimensionId]);
      if (defaultMeasurementMaxDepth) {
        return {
          ...dimension,
          defaultValue: defaultMeasurementMaxDepth,
        };
      }
    }

    return {
      ...dimension,
      defaultValue: dimension.defaultValue || defaultMeasurements[dimensionId],
    };
  });
}

export function generateShapes({ shapes }, materials) {  
  return shapes.filter((shape) => {
    if (!availableShapes[shape.id]) {
      // eslint-disable-next-line no-console
      console.error('Excluding unknown shape:', shape.id);
      return false;
    }

    const availableShape = availableShapes[shape.id];
    if (availableShape.conditions) {
      const hasValidExpressions = materials.some((material) => {
        return material.expressions.some((expression) => expression.thicknesses[0].depths.some(({ maxDepth }) => availableShape.conditions({ maxDepth })));
      });
      if (!hasValidExpressions) {
        // eslint-disable-next-line no-console
        console.error(`Excluding shape: ${shape.id} due to no valid expressions`);
      }
      return hasValidExpressions;
    }
    return true;
  }).map((shape) => ({
    id: shape.id,
    ...availableShapes[shape.id],
    dimensions: withDefaultMeasurements(availableShapes[shape.id].dimensions, shape.defaultMeasurements, shape.id === 'irregular' ? materials : false),
    wallLocations: filterWallLocations(availableShapes[shape.id].wallLocations, shape.wallLocations),
    overhangSides: _.map(availableShapes[shape.id].overhangSides, (sides, key) => ({
      id: key,
      ...sides,
    })),
  }))
  .filter((shape) => {
    if (shape.wallLocations.length === 0) {
       // eslint-disable-next-line no-console
      console.error('Excluding shape:', shape.id, 'due to missing wall locations');
      return false;
    }
    if (!_.every(shape.dimensions, (dim) => dim.type === types.CALCULATED ? true : dim.defaultValue)) {
      // eslint-disable-next-line no-console
      console.error('Excluding shape:', shape.id, 'due to missing default values');
      return false;
    }
    return true;
  });
}

/**
 * Removes calculated and constant measurements.
 * @param {Map} dimensions
 * @param {object} measurements
 */
export const filterMeasurements = (dimensions, measurements) => {
  return measurements.filter((measurement, dimension) => filterDimension(dimensions.get(dimension).toJS()));
};

/**
 * Filters calculated and constant dims.
 * @param {Object} dimensions
 * @return {bool} true if allowed, else false
 */
export const filterDimension = (dim) => {
  return !dim.constant && dim.type !== types.CALCULATED;
};
